import _ from "underscore";
import { isNotEmpty } from "../../framework/utils";
import M from "../../strings";
import { format, optional } from "../../utils/lang";

export function formatStoreAddress(store) {
    const {address, municipality, province} = store;
    
    if (isNotEmpty(address) && isNotEmpty(municipality) && isNotEmpty(province)) {
        return format(M("storeAddressFormatString"), municipality, province, address)
    } else {
        return address;
    }
}

export function getStoreDescription(store, linebreak = false) {
    const separator = linebreak ? "\n" : " ",
        {description, storeType} = store,
        storeTypeDescription = optional(() => storeType.description),
        output = [];

    if (isNotEmpty(storeTypeDescription)) {
        output.push(storeTypeDescription);
    }

    if (isNotEmpty(description)) {
        output.push(description);
    }

    return output.join(separator);
}